import { Component, EventEmitter, ViewChild, Output, ElementRef, } from "@angular/core";
import { MatTableDataSource, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { MessagesGeneral, MessagesTitles, MessagesStatus, } from "../../../../models/messages";
import Swal from "sweetalert2";
import { DocumentoNegociableService } from "../../../../services/documento-negociable/documento-negociable.service";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormGroup, FormControl } from "@angular/forms";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-generar-inversion",
  templateUrl: "./generar-inversion.component.html",
  styleUrls: ["./generar-inversion.component.scss"],
  providers: [
    DatePipe,
    MessagesTitles,
    MessagesGeneral,
    MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GenerarInversionComponent {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  
  formularioCrearFondo: FormGroup;
  datosEnviar2: any = [];
  user: any;
  loading: boolean = false;
  idDesembolso: any;
  datosEnviar: any = [];
  dataSource: any;
  dataLiquidacion: any;
  arrayFondo: any;

  checkboxStates = {}
  proveedor: any;
  adquirente: any;
  fechaLiquidacion: Date = new Date();
  idComprobante: any
  form: FormGroup;

  @Output() cerrarGenerarInversion = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();

  @ViewChild("TABLE", { static: true }) table: ElementRef;
  displayedColumns: string[] = ["Serie", "Numero", "idComprobante"];
  data: any = { "Data": [] };
  constructor(
    private docNegociableService: DocumentoNegociableService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    this.arrayFondo = this.docNegociableService.arrayFondo;
    this.datosEnviar2 = this.docNegociableService.arrayFondo;
    this.idComprobante = this.docNegociableService.arrayFondo[0].idComprobante

    this.proveedor = this.arrayFondo[0].RazonSocialProveedor;
    this.adquirente = this.arrayFondo[0].RazonSocialAdquirente;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.dataSource = new MatTableDataSource(this.arrayFondo);

    this.formularioCrearFondo = new FormGroup({
      "idComprobante": new FormControl(''),
      "Participante": new FormControl(''),
      "RUT_Titular": new FormControl(''),
    })
  }

  participante(event) {
    this.formularioCrearFondo.controls['Participante'].setValue(event)
  }
  rutTitular(event) {
    this.formularioCrearFondo.controls['RUT_Titular'].setValue(event)
  }
  guardarFondo() {
    this.loading = true;

    for (let array of this.datosEnviar2) {

      this.data.Data.push(
        {
          'idComprobante': array.idComprobante,
          'Participante': this.formularioCrearFondo.controls['Participante'].value,
          'RUT_Titular': this.formularioCrearFondo.controls['RUT_Titular'].value
        }
      )
    }

    this.loading = true;
    Swal.fire({
      title: "Espere",
      text: "Guardando Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.docNegociableService.CrearFondo(this.data).subscribe(
      () => {
        Swal.fire({
          title: "Felicidades",
          text: "Fondo Creado",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then((res) => {
          if (res.value) {
            this.cerrarGenerarInversion.emit();
            this.refresh.emit();
            this.loading = false;
          }
        });
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Fondo no creado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );
  }

  CerrarPopUp() {
    this.cerrarGenerarInversion.emit();
  }
}